// Main Application Entry Point
import { initAutoLogin, refreshSession } from './core/auth.js';
import { switchView } from './core/router.js';
import { state } from './core/state.js';
import { initDashboard } from './modules/dashboard.js';
import { initProfileMFA } from './modules/profile.js';
import { initSystemBranding } from './utils/branding.js';

// Ensure MFA helpers are on window even when the page uses the bundled entry only
window.initProfileMFA = initProfileMFA;

console.log('[App] Initializing modular application...');

// Global error handler (log real script URL — "page:644" is often EOF mapped to the HTML document, not the failing file)
window.addEventListener('error', (event) => {
    console.error('[App] Global error:', event.error);
    if (event.filename) {
        console.error('[App] Script location:', event.filename + ':' + event.lineno + ':' + event.colno);
    }
    if (event.error && event.error.stack) {
        console.error('[App] Stack:', event.error.stack);
    }
});

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', async () => {
    // CRITICAL: Do not run main app logic on login page
    if (window.location.pathname === '/login') {
        return;
    }

    try {
        console.log('[App] DOM ready, initializing...');

        initSystemBranding();
        initAutoLogin();

        // Initialize dashboard stats if logged in (refresh permissions before UI that checks them)
        if (state.authToken) {
            await refreshSession();
            initDashboard();

            // Restore view based on server render or fallback
            // Prioritize what the server actually rendered to match the DOM
            let viewToLoad = window.SERVER_RENDERED_VIEW;

            // Clean up view name if it has spaces or extra chars
            if (viewToLoad) {
                viewToLoad = viewToLoad.trim();
            }

            if (!viewToLoad) {
                // Fallback to local storage or default
                viewToLoad = window.localStorage.getItem('current_view') || 'dashboard';
            }

            console.log('[App] Initializing view:', viewToLoad);
            switchView(viewToLoad);

            if (window.location.pathname === '/profile' || viewToLoad === 'profile') {
                initProfileMFA();
            }
        }

        console.log('[App] Initialization complete');
    } catch (error) {
        console.error('[App] Initialization error:', error);
    }
});

// Cleanup on page unload
window.addEventListener('beforeunload', () => {
    console.log('[App] Page unloading...');
});

console.log('[App] Module loaded successfully');
